module.exports = __webpack_public_path__ + "media/images/mobile/abouts/7-0b8effc38a0941d7fe86b15472b4e0b5.jpg";